// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"16":"64d78f6e","75":"5140898b","404":"013e5441","627":"c78593a4"}[chunkId] + ".css";
};